import { render, staticRenderFns } from "./GroupsTeams.vue?vue&type=template&id=5a79bbde&scoped=true&"
import script from "./GroupsTeams.vue?vue&type=script&lang=js&"
export * from "./GroupsTeams.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTeams.vue?vue&type=style&index=0&id=5a79bbde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a79bbde",
  null
  
)

export default component.exports